import { useIntl } from 'react-intl'
import { type DialogState } from 'ariakit'
import { csx, Stack } from '@vtex/admin-ui'
import { CustomModal } from '@/components/CustomModal'
import { FullPageSpinner } from '@/components/FullPageSpinner'
import { useSKUs } from '@/hooks/useSKUs'
import type { Product } from '@/types/product'

import { SkuOffersTable } from './components'

import * as styles from './ProductSKUsOffersModal.styles'

type ProductSKUsOffersProps = {
  product?: Product
  state: DialogState
  skuIdToOpen?: number
}

export const ProductSKUsOffersModal = ({
  state,
  product,
  skuIdToOpen = 0,
}: ProductSKUsOffersProps) => {
  const { data: skus = [], isLoading } = useSKUs(
    product?.id ?? 0,
    state.mounted && !!product?.id
  )
  const { formatMessage } = useIntl()

  return (
    <CustomModal
      state={state}
      title={formatMessage({
        id: 'admin/admin.catalog.price-and-inventory-tab-label',
        defaultMessage: 'Price and Inventory',
      })}
    >
      <Stack className={csx(styles.container)} space="$space-0">
        {isLoading && <FullPageSpinner maxHeight="400px" />}

        {skus.map((sku) => {
          if (!product) return null

          return (
            <SkuOffersTable
              sku={sku}
              defaultExpanded={skuIdToOpen === sku.id || skus?.length === 1}
              product={product}
              key={sku.id}
            />
          )
        })}
      </Stack>
    </CustomModal>
  )
}
